<template>
  <div id="app">
    <slide-y-up-transition>
      <div id="header" v-show="showFirst">
        <div id="open-menu-mobile">
          <div @click="menuOpen = true">
            <img src="./assets/img/logo-open-menu.png" alt="">
          </div>
        </div>
        <div class="container">
          <div id="left">
            International<br>
            Influencer<br>
            Marketing<br>
            Agency
          </div>
          <div id="nav">
            <router-link to="/influencers">Influencers</router-link>
            <router-link to="/services">Services</router-link>
            <router-link class="logo" to="/">
              <img src="./assets/img/logo.png" style="width: 130px" alt="">
            </router-link>
            <!-- <router-link class="logo" to="/">Alksar</router-link> -->
            <router-link to="/about">About us</router-link>
            <router-link to="/contact">Contact</router-link>
          </div>
          <div id="right">
            <router-link class="button" to="/contact">Join now</router-link>
          </div>
        </div>
      </div>
    </slide-y-up-transition>
    <fade-transition>
      <div v-if="showSecond">
        <vue-page-transition name="fade">
          <router-view />
        </vue-page-transition>
      </div>
    </fade-transition>
    <slide-y-up-transition>
      <div id="footer" v-show="showThird">
        <div class="container">
          <div class="links">
            <div class="title">Legal</div>
            <ul>
              <li><router-link to="/terms-and-conditions">Terms & Conditions</router-link></li>
              <li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
              <li><router-link to="/cookies">Cookies</router-link></li>
            </ul>
          </div>
          <div class="copyright">
            <div class="logo">
              <img src="./assets/img/logo.png" style="width: 130px;opacity: .3" alt="">
            </div>
            <div class="copyright-info">
              Copyright &copy; 2020<br>
              All Rights Reserved.
            </div>
          </div>
        </div>
      </div>
    </slide-y-up-transition>
    <slide-y-up-transition>
      <div v-if="isLoading" id="loader">
        <img src="./assets/img/loading-logo.png">
        <img src="./assets/img/logo.png" style="width: 130px" alt="">
        <div class="description">Loading...</div>
      </div>
    </slide-y-up-transition>

    <slide-y-up-transition>
      <div v-if="menuOpen" id="menu-mobile">
        <div>
          <div @click="menuOpen = false" class="close">
            <img src="./assets/img/logo-close-menu.png" alt="">
          </div>
          <div class="logo"><img src="./assets/img/logo.png" style="width: 130px" alt=""></div>
          <ul class="menu">
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/influencers">Influencers</router-link></li>
            <li><router-link to="/services">Services</router-link></li>
            <li><router-link to="/about">About us</router-link></li>
            <li><router-link to="/contact">Contact</router-link></li>
          </ul>
        </div>
        <div>
          <router-link class="button" to="/contact">Join now</router-link>
          <div class="hr"></div>
          <div class="tagline">International Influencer<br>Marketing Agency</div>
          <div class="hr"></div>
          <div><router-link to="/contact"><span class="instagram"></span></router-link></div>
          <div class="hr"></div>
          <ul class="footer">
            <li><router-link to="/terms-and-conditions">Terms & Conditions</router-link></li>
            <li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
            <li><router-link to="/cookies">Cookies</router-link></li>
          </ul>
          <div class="copyright">Copyright &copy; 2020<br>All Rights Reserved.</div>
        </div>
      </div>
    </slide-y-up-transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isLoading: true,
      showFirst: false,
      showSecond: false,
      showThird: false,
      menuOpen: false,
      imagesToPreload: [
        require("./assets/img/bg/about.jpg"),
        require("./assets/img/bg/contact.jpg"),
        require("./assets/img/bg/home.jpg"),
        require("./assets/img/bg/julien.jpg"),
        require("./assets/img/bg/laura.jpg"),
        require("./assets/img/bg/manon.jpg"),
        require("./assets/img/bg/nikola.jpg"),
        require("./assets/img/bg/services.jpg"),
        require("./assets/img/logo-top.png"),
        require("./assets/img/logo-top-hover.png"),
        require("./assets/img/logo-bottom.png"),
        require("./assets/img/logo-bottom-hover.png"),
        require("./assets/img/about-logo.png"),
        require("./assets/img/footer-logo.png"),
        require("./assets/img/instagram.png"),
        require("./assets/img/social/instagram.png"),
        require("./assets/img/social/snapchat.png"),
        require("./assets/img/social/tiktok.png"),
        require("./assets/img/social/twitter.png"),
      ],
    }
  },
  watch:{
    $route (to, from) {
      if (from.name != 'Influencers')
        document.body.scrollIntoView({behavior: 'smooth', block: 'start'})

      this.menuOpen = false
    }
  },
  created () {
    let imageLoaded = 0;
    for (const imageSrc of this.imagesToPreload) {    
      const img = new Image()
      img.src = imageSrc

      img.onload = () => {
        imageLoaded++
        if (imageLoaded === this.imagesToPreload.length) {
          this.isLoading = false
        }
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.showFirst = true
    }, 300)
    setTimeout(() => {
      this.showSecond = true
    }, 600)
    setTimeout(() => {
      this.showThird = true
    }, 600)
  }
}
</script>